import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import './EditAnswer.css'

class EditAnswer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      text: this.props.payload.text
    }
  }

  dismissPopup () {
    this.props.dispatch(actions.switchEditAnswerPopup({}))
  }

  editQuestion () {
    let newDetails = Object.assign({}, this.props.payload)
    newDetails.text = this.state.text
    this.props.dispatch(actions.socketSendMessage({ action: 'edit-comment', data: newDetails }))
  }

  render () {
    return (
      <div className='dashboard-hey email-invite'>
        <div className='hey-popup' style={{ background: 'white' }}>
          <div className='hey-popup-header'>
            <div className='header-text'>Edit your question</div>

            <img alt='' src='/imgs/close.png' onClick={this.dismissPopup.bind(this)} />
          </div>
          <div className='hey-popup-content'>
            <div className='chat-message'>
              <div name='chat-message'>
                <textarea
                  placeholder='Add a custom message to the player...'
                  className='chat-message'
                  value={this.state.text}
                  onChange={ev => this.setState({ text: ev.target.value })} />
              </div>
            </div>
            {this.state.error && (
              <h4><small className='red'>{this.state.error}</small></h4>
            )}
          </div>
          <div className='hey-popup-button-cont'>
            <button
              onClick={this.editQuestion.bind(this)}
              className='button-bt '>Edit <img alt='' src='/imgs/white-send.png' /></button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    error: state.popup.errors,
    payload: state.popup.payload
  }
}

export default connect(mapStateToProps)(EditAnswer)



// WEBPACK FOOTER //
// ./src/components/common/popups/EditAnswer.js